import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

const Emitter = {
    on: (event: any, fn: (value: any) => void) => eventEmitter.on(event, fn),
    once: (event: any, fn: (value: any) => void) => eventEmitter.once(event, fn),
    off: (event: any, fn: () => void) => eventEmitter.off(event, fn),
    emit: (event: any, payload: any) => eventEmitter.emit(event, payload),
    listeners: (event: any) => eventEmitter.listeners(event),
    removeAllListeners: (event: any) => eventEmitter.removeAllListeners(event)
}

Object.freeze(Emitter);

export default Emitter;
